var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',{attrs:{"loading":_vm.loading,"fields":_vm.fields,"no-buttons":""}},[_c('branch-offices-list',{attrs:{"slot":"appendContent","items":_vm.items,"no-edit":""},slot:"appendContent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }